const GRAPHQL_WEBSOCKET_RETRY_BASE_DELAY_MS = 1_000;
const GRAPHQL_WEBSOCKET_RETRY_JITTER_MS = 1_000;
const MAX_GRAPHQL_WEBSOCKET_RETRY_DELAY_MS = 30 * 1000;
const MAX_GRAPHQL_WEBSOCKET_RETRY_EXPONENT = 5;

export async function waitForGraphQLWebSocketRetry(
  retries: number
): Promise<void> {
  const exponentialDelay =
    GRAPHQL_WEBSOCKET_RETRY_BASE_DELAY_MS *
    2 ** Math.min(retries, MAX_GRAPHQL_WEBSOCKET_RETRY_EXPONENT);
  const delay = Math.min(
    MAX_GRAPHQL_WEBSOCKET_RETRY_DELAY_MS,
    exponentialDelay + Math.random() * GRAPHQL_WEBSOCKET_RETRY_JITTER_MS
  );
  await new Promise((resolve) => setTimeout(resolve, delay));
}
